var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"Banner p-1 text-sm transition font-bold rounded-bd-small py-0 cursor-pointer",class:_vm.banner_bg},[_c('small',{class:_vm.banner_text},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }